import { Injectable } from '@angular/core';
import { DashboardLayout } from './dashboard.types';
import { WebService, lastValueFrom } from '@services';

@Injectable({ providedIn: 'root' })
export class DashboardLayoutService {

  constructor(private webService: WebService) { }
  private storageKey(userId: string) { return `rms.dashboard.v1.${userId}`; }

  load(userId: string): DashboardLayout | null {
    const raw = localStorage.getItem(this.storageKey(userId));
    console.log('Loaded layout', raw);
    if (!raw) return null;
    try { return JSON.parse(raw) as DashboardLayout; } catch { return null; }
  }


  save(userId: string, layout: DashboardLayout) {
    localStorage.setItem(this.storageKey(userId), JSON.stringify(layout));
  }


  clear(userId: string) { localStorage.removeItem(this.storageKey(userId)); }
}
